<template>
  <footer class="footer">
    <!-- 顶部曲线 SVG · paper 色块绘制曲线，上方让背景透出 -->
    <svg class="footer-curve" viewBox="0 0 1440 80" preserveAspectRatio="none" aria-hidden="true">
      <path
        d="M0,0 L1440,0 L1440,30 Q 1260,58 1080,32 Q 900,8 720,32 Q 540,58 360,32 Q 180,8 0,42 Z"
        fill="#faf3e8"
      />
    </svg>

    <!-- 顶部柔光球 -->
    <span class="footer-orb footer-orb-rose"></span>
    <span class="footer-orb footer-orb-honey"></span>
    <span class="footer-orb footer-orb-lavender"></span>

    <div class="footer-top">
      <div class="container">
        <p class="footer-hand font-hand">— 一 个 被 听 见 的 地 方 —</p>
        <h2 class="footer-bigtitle">
          <span class="bt-cn">我 们</span>
          <span class="bt-italic">保 持 联 系。</span>
        </h2>
      </div>
    </div>

    <div class="container footer-grid">
      <!-- 品牌列 -->
      <section class="col col-brand">
        <router-link to="/" class="brand">
          <img src="@/assets/images/logo/logo.png" alt="坤和静界" class="brand-logo"/>
          <!-- <span class="brand-text">
            <span class="brand-cn">坤 和 静 界</span>
            <span class="brand-en font-hand">艺术疗愈空间 · 自 2024</span>
          </span> -->
        </router-link>

        <p class="brand-body">
          广东省育家心理学研究院旗下<br/>
          艺术疗愈品牌
        </p>
        <p class="brand-loc">
          广州 · 琶洲数字科技产业园<br/>
          A4 栋 5 楼 509
        </p>
      </section>

      <!-- 联系列 -->
      <section class="col col-call">
        <p class="col-label font-hand">随 时 联 系 我 们</p>
        <a href="tel:19927640438" class="big-phone">
          <span class="bp-num">199 2764 0438</span>
          <span class="bp-arrow">→</span>
        </a>
        <div class="contact-rows">
          <div class="cr">
            <span class="cr-label">微信</span>
            <span class="cr-val">19927640438</span>
            <button class="cr-copy" @click="copyPhone">复制</button>
          </div>
          <div class="cr">
            <span class="cr-label">地址</span>
            <span class="cr-val">广州市海珠区琶洲数字科技产业园 A4 栋 5 楼 509坤和静界艺术疗愈空间</span>
           
             <button class="cr-copy"> <a
              href="https://uri.amap.com/marker?position=113.407075,23.08471&name=坤和静界艺术疗愈空间&coordinate=gaode&callnative=1"
              target="_blank"
            >导航</a></button>
          </div>
        </div>
      </section>

      <!-- 导航列 -->
      <section class="col col-nav">
        <p class="col-label font-hand">了 解 更 多</p>
        <ul class="nav-cols">
          <li><router-link to="/services/youth">春藤计划</router-link></li>
          <li><router-link to="/services/entrepreneur">躺平计划</router-link></li>
          <li><router-link to="/services/training">疗愈师认证</router-link></li>
          <li><router-link to="/services/popularize">心理科普</router-link></li>
          <li class="sep"></li>
          <li><router-link to="/about">关于我们</router-link></li>
          <li><router-link to="/team">疗愈师团队</router-link></li>
          <li><router-link to="/contact">联系方式</router-link></li>
          <li>
            <a
              href="https://yc.sll81.com/wuxiu/html/open-mini.html?path=%2Fpages%2Findex%2Findex"
              target="_blank"
            >微信小程序 <i class="fas fa-external-link-alt"></i></a>
          </li>
        </ul>
      </section>
    </div>

    <div class="footer-bottom">
      <div class="container fb-row">
        <p class="fb-left">© 2026 坤和静界 · 广东省育家心理学研究院</p>
        <p class="fb-mid font-hand">用 心 慢 慢 做</p>
        <p class="fb-right">
          <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备17019109号-1</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    copyPhone() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText("19927640438")
          .then(() => this.$message.success("已复制"))
          .catch(() => this.fallback());
      } else this.fallback();
    },
    fallback() {
      const ta = document.createElement("textarea");
      ta.value = "19927640438";
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); this.$message.success("已复制"); }
      catch { this.$message.error("复制失败"); }
      document.body.removeChild(ta);
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  position: relative;
  background: var(--sage);
  color: var(--milk);
  overflow: hidden;
  padding-top: clamp(110px, 11vw, 160px);  /* 顶部留出曲线 80px + 内容 padding */
  margin-top: 0;
}

/* 顶部曲线 SVG · 绝对定位贴顶 · paper 色块"咬"出曲线 */
.footer-curve {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 80px;
  display: block;
  pointer-events: none;
  z-index: 5;
}

.footer-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.4;
  pointer-events: none;
  z-index: 0;
}
.footer-orb-rose {
  width: 420px; height: 420px;
  background: radial-gradient(circle, var(--rose) 0%, transparent 70%);
  top: 10%; right: -100px;
}
.footer-orb-honey {
  width: 320px; height: 320px;
  background: radial-gradient(circle, var(--honey) 0%, transparent 70%);
  bottom: 5%; left: 15%;
}
.footer-orb-lavender {
  width: 360px; height: 360px;
  background: radial-gradient(circle, var(--lavender) 0%, transparent 70%);
  top: 50%; right: 30%;
}

/* 顶部巨字 */
.footer-top {
  position: relative;
  z-index: 2;
  padding-bottom: clamp(40px, 5vw, 60px);
}
.footer-hand {
  font-size: 20px;
  color: var(--honey-pale);
  margin-bottom: 12px;
  padding-left: 8%;
}
.footer-bigtitle {
  font-family: var(--font-cn);
  font-weight: 500;
  font-size: clamp(48px, 7vw, 96px);
  line-height: 1.1;
  letter-spacing: 0.08em;
  color: var(--milk);
  padding-left: 6%;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 18px;
  .bt-cn {
    color: var(--milk);
  }
  .bt-italic {
    color: var(--honey-pale);
  }
}

.footer-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1.1fr 1fr 1fr;
  gap: clamp(40px, 5vw, 80px);
  padding-bottom: clamp(60px, 7vw, 90px);
}

/* 品牌列 */
.brand {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 26px;
  color: var(--milk);
}
.brand-logo {
  height: 48px;
  filter: brightness(0) invert(1);
}
.brand-text { display: inline-flex; flex-direction: column; line-height: 1.1; }
.brand-cn {
  font-family: var(--font-cn);
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.2em;
  color: var(--milk);
}
.brand-en {
  font-size: 14px;
  color: var(--honey-pale);
  margin-top: 4px;
}
.brand-body {
  font-family: var(--font-body);
  font-size: 14px;
  line-height: 1.95;
  color: rgba(255, 250, 240, 0.85);
  margin-bottom: 20px;
}
.brand-loc {
  font-family: var(--font-body);
  font-size: 13px;
  line-height: 1.9;
  color: rgba(255, 250, 240, 0.7);
}

/* 列标签 */
.col-label {
  font-size: 18px;
  color: var(--honey-pale);
  margin-bottom: 18px;
}

/* 联系列 */
.col-call { padding-top: 8px; }
.big-phone {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  background: var(--milk);
  border-radius: 18px;
  color: var(--ink);
  margin-bottom: 24px;
  transform: rotate(-1.5deg);
  box-shadow: 0 12px 30px -10px rgba(0,0,0,0.25);
  transition: transform 0.4s, box-shadow 0.4s;
  .bp-num {
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 26px;
    letter-spacing: 0.02em;
    color: var(--rose-d);
  }
  .bp-arrow {
    font-family: var(--font-display);
    font-size: 22px;
    color: var(--sage-d);
    transition: transform 0.3s;
  }
  &:hover {
    transform: rotate(0deg) translateY(-2px);
    box-shadow: 0 16px 36px -10px rgba(0,0,0,0.3);
    .bp-arrow { transform: translateX(6px); }
  }
}
.contact-rows {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cr {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px dashed rgba(255, 250, 240, 0.25);
  .cr-label {
    font-family: var(--font-hand);
    font-size: 15px;
    color: var(--honey-pale);
    flex: 0 0 36px;
  }
  .cr-val {
    flex: 1;
    font-family: var(--font-body);
    font-size: 13.5px;
    color: rgba(255, 250, 240, 0.9);
  }
  .cr-link { color: var(--honey-pale); &:hover { color: var(--milk); } }
  .cr-copy {
    font-family: var(--font-body);
    font-size: 11px;
    padding: 4px 12px;
    background: rgba(255, 250, 240, 0.15);
    color: var(--milk);
    border-radius: 999px;
    transition: background 0.3s;
    &:hover { background: var(--rose); }
  }
}

/* 导航列 · 不对齐设计 */
.nav-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
  li {
    a {
      font-family: var(--font-body);
      font-size: 13.5px;
      color: rgba(255, 250, 240, 0.78);
      transition: color 0.25s, padding 0.3s;
      &:hover { color: var(--honey-pale); padding-left: 4px; }
    }
    &.sep {
      grid-column: span 2;
      height: 1px;
      background: linear-gradient(90deg, rgba(255,250,240,0.25), transparent);
      margin: 6px 0;
    }
  }
}

/* 底栏 */
.footer-bottom {
  position: relative;
  z-index: 2;
  padding: 18px 0;
  border-top: 1px solid rgba(255, 250, 240, 0.15);
  background: rgba(0, 0, 0, 0.1);
}
.fb-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 18px;
  font-size: 12px;
  color: rgba(255, 250, 240, 0.55);
  a { color: inherit; &:hover { color: var(--milk); } }
}
.fb-left { text-align: left; }
.fb-mid {
  font-size: 15px;
  color: var(--honey-pale);
  text-align: center;
}
.fb-right { text-align: right; }

@media (max-width: 960px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
  .col-brand { grid-column: span 2; }
  .footer-bigtitle { font-size: clamp(40px, 10vw, 64px); padding-left: 0; }
  .footer-hand { padding-left: 0; }
}

@media (max-width: 640px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 36px;
  }
  .col-brand { grid-column: span 1; }
  .nav-cols { grid-template-columns: 1fr; }
  .fb-row { grid-template-columns: 1fr; gap: 6px; text-align: center; }
  .fb-left, .fb-right { text-align: center; }
}
</style>
